import {  IonCard } from "@ionic/react";
import React, {  useState } from "react";
import "./NotesCard.scss";

import { notesContainerService } from "../EmsNotesContainer.service";

interface notesParams {
  notesData: any;
}

const NotesCard: React.FC<notesParams> = (props) => {

  const [isLoaderActive, setLoaderStatus] = useState(true);

  async function updateNotesList(addParams: any) {
    setLoaderStatus(true);
    const respUpdatedNotesCardResult: any =
      await notesContainerService.getUpdatedNotesCardList(addParams);
    if (respUpdatedNotesCardResult.isSuccess) {
      const socketParams = {
        type: "notes",
      };
    } else {
      console.log("error");
      notesContainerService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  return (
    <IonCard
      className="ems-notes-card-wrapper"
      id={`notesCardId-${props.notesData.id}`}
    >
      <div className="time-data"></div>
      <div className="notes-card-data">
        <div className="data-header">
          <span className="doc-name">{props.notesData.userName}</span>

          <span className="notes-time">{props.notesData.dateTime}</span>
        </div>
        <div className="text-message">{props.notesData.note}</div>
      </div>
    </IonCard>
  );
};

export default NotesCard;
